/*
  GO Motorsports header: announcement rotation, storefront switch, desktop menus, mobile drawer,
  sticky behavior, predictive search and the cart count badge.
*/
(function () {
  var header = document.querySelector('[data-header]');
  var STORE_KEY = 'go-storefront';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Announcement bars ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var messages = bar.querySelectorAll('.announcement__message');
    var index = 0;
    var timer;
    var ms = (Number(bar.dataset.speed) || 0) * 1000;

    function show(n) {
      index = (n + messages.length) % messages.length;
      messages.forEach(function (m, i) {
        m.classList.toggle('is-active', i === index);
        m.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
    }
    function start() {
      clearInterval(timer);
      if (ms > 0 && !reduceMotion) timer = setInterval(function () { show(index + 1); }, ms);
    }

    bar.querySelector('[data-prev]').addEventListener('click', function () { show(index - 1); start(); });
    bar.querySelector('[data-next]').addEventListener('click', function () { show(index + 1); start(); });
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', function () { clearInterval(timer); });
    bar.addEventListener('focusout', start);
    document.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(messages, e.target);
      if (i > -1) { show(i); clearInterval(timer); }
    });
    start();
  });

  if (!header) return;

  /* ---------- Storefront switch ---------- */
  function setStore(index, remember) {
    document.querySelectorAll('[data-store-switch]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.storeSwitch === String(index) ? 'true' : 'false');
    });
    document.querySelectorAll('[data-store-tab]').forEach(function (tab) {
      tab.dataset.selected = tab.dataset.storeTab === String(index) ? 'true' : 'false';
    });
    document.querySelectorAll('[data-store-nav]').forEach(function (nav) {
      nav.hidden = nav.dataset.storeNav !== String(index);
    });
    closeMenus();
    if (remember) {
      try { sessionStorage.setItem(STORE_KEY, String(index)); } catch (e) {}
    }
  }

  // On a storefront's own page (the page its header tab links to), select that tab, whatever the server decided.
  var here = window.location.pathname.replace(/\/+$/, '') || '/';
  var ownTab = Array.prototype.find.call(document.querySelectorAll('.header [data-store-tab]'), function (tab) {
    var target = (tab.pathname || '').replace(/\/+$/, '') || '/';
    return tab.getAttribute('href') !== '#' && target === here;
  });
  if (ownTab) {
    header.dataset.matched = 'true';
    setStore(ownTab.dataset.storeTab, true);
  }

  // A page that belongs to one side always shows that side. Otherwise keep the shopper's last pick.
  if (header.dataset.matched !== 'true') {
    try {
      var saved = sessionStorage.getItem(STORE_KEY);
      if (saved !== null && document.querySelector('[data-store-nav="' + saved + '"]')) setStore(saved, false);
    } catch (e) {}
  } else {
    var current = document.querySelector('[data-store-switch][aria-pressed="true"]');
    if (current) {
      try { sessionStorage.setItem(STORE_KEY, current.dataset.storeSwitch); } catch (e) {}
    }
  }

  document.querySelectorAll('[data-store-switch]').forEach(function (button) {
    button.addEventListener('click', function () {
      setStore(button.dataset.storeSwitch, true);
      // On phones the desktop menu is hidden, so picking a side opens the drawer on that side's menu.
      if (!desktop.matches && header.contains(button)) openDrawer(button);
    });
  });

  // The header tabs are links to each storefront's page; remember the side so pages that belong to neither
  // (cart, policies) keep showing it.
  document.querySelectorAll('[data-store-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      try { sessionStorage.setItem(STORE_KEY, tab.dataset.storeTab); } catch (e) {}
    });
  });

  /* ---------- Desktop menus ---------- */
  var toggles = header.querySelectorAll('[data-menu-toggle]');
  var hoverTimer;

  // Closing folds the panel away (.is-closing in go-header.css) before hiding it. Switching straight to
  // another menu hides the old panel at once so the two never overlap.
  var reduceMenuMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function closeDelay() {
    var value = getComputedStyle(document.documentElement).getPropertyValue('--duration-short').trim();
    return reduceMenuMotion.matches ? 0 : (parseFloat(value) || 0) * (value.indexOf('ms') > -1 ? 1 : 1000);
  }
  function hidePanel(panel, animate) {
    if (panel.hidden) return;
    clearTimeout(panel.goCloseTimer);
    var delay = animate ? closeDelay() : 0;
    if (!delay) {
      panel.classList.remove('is-closing');
      panel.hidden = true;
      return;
    }
    panel.classList.add('is-closing');
    panel.goCloseTimer = setTimeout(function () {
      panel.classList.remove('is-closing');
      panel.hidden = true;
    }, delay);
  }
  function closeMenus(except) {
    if (!toggles) return;
    toggles.forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      hidePanel(document.getElementById(t.getAttribute('aria-controls')), !except);
    });
  }
  function openMenu(toggle) {
    closeMenus(toggle);
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    clearTimeout(panel.goCloseTimer);
    panel.classList.remove('is-closing');
    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  toggles.forEach(function (toggle) {
    var item = toggle.parentElement;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') closeMenus();
      else openMenu(toggle);
    });
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMenu(toggle);
        var first = panel.querySelector('a');
        if (first) first.focus();
      }
    });
    item.addEventListener('mouseenter', function () {
      if (!canHover.matches) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { openMenu(toggle); }, 80);
    });
    item.addEventListener('mouseleave', function () {
      if (!canHover.matches) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { closeMenus(); }, 150);
    });
    // Arrow keys move between links inside an open panel.
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (i === -1) return;
      e.preventDefault();
      var next = links[i + (e.key === 'ArrowDown' ? 1 : -1)];
      if (next) next.focus();
      else if (e.key === 'ArrowUp') toggle.focus();
    });
  });

  // Close when focus or a click leaves the menu, or on Escape.
  header.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !e.relatedTarget.closest('.menu__item')) closeMenus();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.menu__item')) closeMenus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = header.querySelector('[data-menu-toggle][aria-expanded="true"]');
    if (open) { closeMenus(); open.focus(); }
    if (!search.hidden) closeSearch(true);
    if (!drawer.hidden) closeDrawer();
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var drawerPanel = drawer.querySelector('[data-drawer-panel]');
  var drawerToggle = header.querySelector('[data-drawer-open]');
  var drawerReturn = drawerToggle;

  function openDrawer(returnTo) {
    drawerReturn = returnTo || drawerToggle;
    drawer.hidden = false;
    document.body.classList.add('has-drawer-open');
    drawerToggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawerPanel.focus();
    });
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('has-drawer-open');
    drawerToggle.setAttribute('aria-expanded', 'false');
    setTimeout(function () { drawer.hidden = true; }, reduceMotion ? 0 : 300);
    if (drawerReturn) drawerReturn.focus();
  }

  drawerToggle.addEventListener('click', function () { openDrawer(drawerToggle); });
  drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  // Keep Tab inside the open drawer.
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      drawerPanel.querySelectorAll('a[href], button, summary'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === drawerPanel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
  desktop.addEventListener('change', function (e) {
    if (e.matches && !drawer.hidden) closeDrawer();
  });

  /* ---------- Sticky ---------- */
  var sectionEl = header.closest('.shopify-section');
  var lastY = window.scrollY;

  function measure() {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  measure();
  window.addEventListener('resize', measure);

  // The compact point is measured once (and on resize) so the header shrinking doesn't move it.
  var compactAt = header.offsetHeight;
  window.addEventListener('resize', function () {
    if (!header.classList.contains('is-scrolled')) compactAt = header.offsetHeight;
  });
  if (header.dataset.sticky !== 'none') {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > compactAt);
    }, { passive: true });
  }

  if (header.dataset.sticky === 'scroll-up' && sectionEl) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var hide = y > lastY && y > header.offsetHeight * 2 && search.hidden && drawer.hidden;
      if (hide && header.querySelector('[data-menu-toggle][aria-expanded="true"]')) closeMenus();
      sectionEl.classList.toggle('is-header-hidden', hide);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Search ---------- */
  var search = header.querySelector('[data-search]');
  var searchInput = search.querySelector('[data-search-input]');
  var results = search.querySelector('[data-predictive-results]');
  var searchToggle = header.querySelector('[data-search-open]');
  var searchTimer;
  var searchAbort;

  function openSearch() {
    closeMenus();
    search.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    searchInput.focus();
  }
  function closeSearch(returnFocus) {
    search.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) searchToggle.focus();
  }

  searchToggle.addEventListener('click', function () {
    if (search.hidden) openSearch(); else closeSearch(true);
  });
  search.querySelector('[data-search-close]').addEventListener('click', function () { closeSearch(true); });

  searchInput.addEventListener('input', function () {
    clearTimeout(searchTimer);
    var q = searchInput.value.trim();
    if (!q) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(function () { fetchResults(q); }, 250);
  });
  searchInput.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      var first = results.querySelector('a');
      if (first) { e.preventDefault(); first.focus(); }
    }
  });
  results.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = Array.prototype.slice.call(results.querySelectorAll('a'));
    var i = links.indexOf(document.activeElement);
    if (i === -1) return;
    e.preventDefault();
    var next = links[i + (e.key === 'ArrowDown' ? 1 : -1)];
    (next || searchInput).focus();
  });

  function fetchResults(q) {
    if (searchAbort) searchAbort.abort();
    searchAbort = 'AbortController' in window ? new AbortController() : null;
    var url = header.dataset.predictiveUrl +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,tag,vendor' +
      '&section_id=predictive-search';
    fetch(url, searchAbort ? { signal: searchAbort.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-predictive-content]');
        results.innerHTML = content ? content.outerHTML : '';
      })
      .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = ''; });
  }

  /* ---------- Cart count ---------- */
  var countEl = header.querySelector('[data-cart-count]');

  function setCount(n) {
    if (!countEl) return;
    var label = countEl.querySelector('.visually-hidden');
    countEl.textContent = '';
    if (label) countEl.appendChild(label);
    countEl.appendChild(document.createTextNode(n));
    countEl.hidden = n === 0;
    countEl.style.display = '';
    countEl.classList.remove('is-bumped');
    void countEl.offsetWidth;
    countEl.classList.add('is-bumped');
  }

  // Other scripts (product form, cart drawer) dispatch: document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') setCount(e.detail.item_count);
  });
  // Pages restored from the back-forward cache can show an old count.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); });
  });
})();
